import './polyfills';
import './consolePatch';

// Initialize Sentry at the JS entry — BEFORE expo-router and the background
// task — so the native crash handler is armed on EVERY JS context start,
// including headless background-location JobService relaunches that never
// evaluate app/_layout.tsx. Without this, the top production crash
// (TaskService.executeTask NPE) was invisible to Sentry and only ever showed in
// the Play Console. See src/lib/sentryInit.ts for the full rationale.
import './src/lib/sentryInit';

// Register the Android background-location task at the JS entry, BEFORE
// expo-router. A headless JobService relaunch (Android delivering a background
// location batch) starts a fresh JS context but never evaluates expo-router
// route modules, so registering the task inside app/_layout.tsx left the
// handler undefined on those launches → NullPointerException in
// expo.modules.taskManager.TaskService.executeTask. index.js runs on EVERY JS
// context start (foreground and headless), so defineTask is guaranteed before
// the native task fires. Pure JS — ships via EAS Update.
import { Platform } from 'react-native';
if (Platform.OS !== 'web') {
  require('./src/hooks/useLocationTracking');
}

export { default } from 'expo-router/entry';
